<template>
<div class="chapter">
<div class="inner_page">
<div class="center">
<p class="no-indent"><img alt="" src="Images/jacket.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Exodus.vue?9b97007a